import { useTranslation } from 'react-i18next';
import {
  CancelCircleIcon,
  CheckCircleIcon,
  Flex,
  theme,
} from '@kvdbil/components';
import { FailedImage, UploadResult } from '@shared/types';

import styled from 'styled-components';

const Container = styled(Flex)`
  padding-top: 1rem;
  padding-bottom: 1rem;
  flex-direction: column;
  gap: 1rem;
`;

const FeedbackList = styled(Flex)`
  overflow: auto;
  max-height: calc(20rem);
`;

const FeedbackListItem = styled(Flex)`
  overflow-wrap: break-word;
  word-break: break-word;
  min-width: 0;
`;

export const UploadFeedback = ({
  success,
  max,
  uploadedImages,
}: {
  success: number;
  max: number;
  uploadedImages: UploadResult[];
}) => {
  const { t } = useTranslation();

  const failedImages = uploadedImages.filter(
    image => image.status !== 'SUCCESS'
  ) as FailedImage[];

  return (
    <Container align={'start'}>
      <FeedbackList direction={'column'}>
        <FeedbackListItem>
          <Flex shrink={0}>
            <CheckCircleIcon
              color={theme.colors.secondary.main}
              width={'1.5rem'}
              height={'1.5rem'}
            />
          </Flex>
          {t('{{successAmount}} of {{totalAmount}} images uploaded', {
            successAmount: success,
            totalAmount: max,
          })}
        </FeedbackListItem>
      </FeedbackList>

      {failedImages.length > 0 && (
        <FeedbackList justify={'start'} align={'start'} direction={'column'}>
          {failedImages.map(image => (
            <FeedbackListItem justify={'start'}>
              <Flex shrink={0}>
                <CancelCircleIcon
                  color={theme.colors.error.main}
                  width={'1.5rem'}
                  height={'1.5rem'}
                />
              </Flex>

              <div>
                {t('{{fileName}} could not be uploaded', {
                  fileName: image.name,
                })}
                {image?.error?.message && (
                  <p>{`${t('Reason')}: "${image?.error?.message}"`}</p>
                )}
              </div>
            </FeedbackListItem>
          ))}
        </FeedbackList>
      )}
    </Container>
  );
};

export default UploadFeedback;
